import React from 'react';
import { RaRecord, useTranslate } from 'react-admin';
import { useTour } from '@react-admin/ra-tour';
import {
    Box,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Button,
    Typography,
} from '@mui/material';
import PlayIcon from '@mui/icons-material/PlayArrow';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { useTourState } from './useTourState';

const Tour = ({ record }: { record: RaRecord }) => {
    const translate = useTranslate();
    const [playedOn, tourStateActions] = useTourState(record.id.toString());
    // eslint-disable-next-line no-unused-vars
    const [, { start }] = useTour();

    const handlePlayClicked = (): void => {
        if (start) {
            start(record.tour);
        }
        tourStateActions.markAsPlayed();
    };

    return (
        <Card
            sx={{
                maxWidth: 345,
                cursor: 'pointer',
                opacity: playedOn ? 0.6 : 0.9,
                transition: 'opacity 0.3s ease-in-out',
                '&:hover,&:focus-within': {
                    opacity: 1,
                },
            }}
            onClick={handlePlayClicked}
        >
            <CardMedia
                sx={{
                    height: 140,
                }}
                image={`${process.env.PUBLIC_URL}/${record.image}`}
                title={record.title}
            />
            <CardContent
                sx={{
                    position: 'relative',
                    minHeight: 125,
                }}
            >
                {!playedOn && (
                    <NewReleasesIcon
                        color="error"
                        fontSize="large"
                        sx={{
                            position: 'absolute',
                            top: 10,
                            right: 10,
                        }}
                    />
                )}
                <Typography variant="h5" component="h2" gutterBottom>
                    {translate(record.title, { _: record.title })}
                </Typography>
                <Typography variant="body2" gutterBottom>
                    {translate(record.comment, { _: record.comment })}
                </Typography>
            </CardContent>
            <CardActions
                sx={{
                    paddingBottom: 0,
                }}
            >
                <Button size="small" startIcon={<PlayIcon />} color="primary">
                    {translate('tours.action.play')}
                </Button>
            </CardActions>
            <Box
                sx={{
                    paddingLeft: 16,
                    paddingTop: 0,
                    paddingBottom: 16,
                }}
            >
                <Typography
                    variant="caption"
                    display="block"
                    color="textSecondary"
                >
                    {!!playedOn
                        ? translate('tours.message.played_on', {
                              date: new Date(playedOn).toLocaleString(),
                          })
                        : translate('tours.message.never_played')}
                </Typography>
            </Box>
        </Card>
    );
};

export default Tour;
